/*
 * 戒导航 · 表情模块（jiedh/emoji）前台初始化
 *
 * 职责（详见 doc/表情资源自托管与表情面板优化设计方案.md 第四节）：
 *   修正 flarum/emoji 表情下拉面板的弹出定位 —— 贴光标、不遮挡正文、不出屏。
 *
 * 注意：initializers.add() 的 name 必须与扩展 ID 对应（本包 ID 为 jiedh/emoji），
 * 它同时决定本初始化器在 Flarum 启动序列中的位置：Flarum 按「扩展启动顺序」
 * 依次执行各扩展注册的初始化器，而本包依赖 flarum/emoji → 本包在其之后执行，
 * 从而保证我们的 extend() 包裹在 flarum/emoji 的 extend() **外层**（即回调后执行）。
 */
import app from 'flarum/forum/app';
import fixEmojiDropdownPosition from './fixEmojiDropdownPosition';
app.initializers.add('jiedh-emoji', () => {
  fixEmojiDropdownPosition();
});